import { IFotoramaData } from '../../../typings/fotorama';
import { IPhotoSchema, IVideoSchema } from '../../types';

export function photosMapper(item: IPhotoSchema): IFotoramaData {
  return {
    full: item.fullUrl,
    img: item.galleryThumbnailUrl,
    thumb: item.thumbnailUrl,
  };
}

export function videosMapper(item: IVideoSchema): IFotoramaData {
  return {
    video: item.url,
  };
}
